/// <reference path="../../../../app.definition.ts" />

import { IAppRootScopeService } from "@/app/app.definition";
import { CacheService } from "@common/service/cache.service";
import { TargetEnum, PermissionsEnum, PermissionService } from "ecv/common/permissions";
import { TeamPermissionService } from "@common/service/teamPermission.service";
import { UserService } from "@common/service/user.service";
import { PaymentService } from "@common/service/payment.service";
import angular from "angular";

interface IEcvCarefeedContent {
    subjectType: string;
    //
}

class EcvCarefeedContent implements IEcvCarefeedContent {

    subjectType: string;
    selectedSubject;
    currentUser;
    isDiscAllowed: boolean;
    toastrMsg: string;
    isBuildBtnDisable: boolean;
    isConnectBtn: boolean;
    isUploadPermited: boolean;

    checkAccessForTeamMemmber: { partyId: any; target: TargetEnum; };

    static $inject = ["CacheService", "$rootScope", "$state", "PaymentService", "TeamPermissionService", "PermissionService", "UserService"];
    constructor(
        private $_cache: CacheService,
        private $rootScope: IAppRootScopeService,
        private $state: ng.ui.IStateService,
        private PaymentService: PaymentService,
        private $_teamPerm: TeamPermissionService,
        private PermissionService: PermissionService,
        private UserService: UserService
    ) {
        this.currentUser = this.$_cache.getUser();
        this.selectedSubject = this.$_cache.getCurrentSubject()
        this.isDiscAllowed = this.$_teamPerm.isDiscussionsAllowed(this.$_cache.getCurrentSubject());
        this.init();
        this.isUploadPermited = true;
    }
    init(): void {
        if (this.selectedSubject) {
            this.checkAccessForTeamMemmber = {
                partyId: this.selectedSubject.teamPartyId,
                target: TargetEnum.TEAMMEMBER
            }
            this.setPermission()
            this.fetchTeamPermissions([this.selectedSubject.teamPartyId]);
        }
    }

    fetchTeamPermissions = (ids: number[]) => {
        this.PermissionService.fetchPermissionsForTarget(ids).catch(e => {
            console.error(e)
        });
    }
    setPermission = () => {
        this.UserService.isUserTeammember(this.selectedSubject).then((s) => {
            this.isConnectBtn = s
            if (!s) {
                this.PermissionService.isActionAllowed(this.checkAccessForTeamMemmber.partyId, TargetEnum.DOCUMENT, PermissionsEnum.CREATE).then((isPermited) => {
                    this.isUploadPermited = isPermited
                })
            } else {
                this.isUploadPermited = true
            }
        });
        if (this.currentUser.userId === this.selectedSubject.ownerId || this.selectedSubject.coCaptain) {
            this.isBuildBtnDisable = false
        }
        else {
            this.PermissionService.isActionAllowed(this.checkAccessForTeamMemmber.partyId, TargetEnum.TEAMMEMBER, PermissionsEnum.CREATE).then((isPermited) => {
                this.isBuildBtnDisable = !isPermited
            })
        }

    }
    redirectAction = (redirectTo: string): boolean => {
        if (redirectTo == 'teams') {
            // redirect to build team page
            this.$state.go('parent-dashboard', { ref: 'build' });
        } else if (redirectTo == 'documents') {
            // redirect to documents page
            this.PaymentService.checkLimitAndProceed("document", () => {
                this.$state.go('organize', { ref: 'cf' });
            });
        } else if (redirectTo == 'discussions') {
            // redirect to discussion page
            this.PaymentService.checkLimitAndProceed("discussion", () => {
                this.$state.go('connect', { ref: 'cf' });
            });
        }

        return true;
    }
}

function carefeedContent(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/carefeedBoard/components/carefeedContent/carefeed-content.directive.html',
        replace: true,
        controller: EcvCarefeedContent,
        controllerAs: 'carefeedContentVm',
        scope: true,
        bindToController: {
            'subjectType': '=?ecvSubjectType'
        },
        link: (): void => {
        }
    }
}

angular.module('eCareVault.common.carefeedBoard').directive('ecvCarefeedContent', carefeedContent);

